import { useEffect } from 'react';

const snippetId = 'ze-snippet';

function ZendeskWidget() {
  useEffect(() => {
    // Load the snippet once per page. Removing its <script> on unmount never removed the widget, and adding
    // it again on the next visit started a second widget, whose config request was cancelled mid-flight
    if (document.getElementById(snippetId)) {
      return;
    }

    const script = document.createElement('script');
    script.id = snippetId;
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=e7bf7adb-d23f-4f5f-80ea-52f97927b4f0';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return null; // This component doesn't render anything in the DOM
}

export default ZendeskWidget;
